<div class="cm-page">
  <header class="cm-head">
    <div>
      <h1 class="cm-title">{{ t('company.members.title', 'Сотрудники') }}</h1>
      <p class="cm-sub">{{ t('company.members.subtitle', 'Добавьте сотрудников компании: у каждого свой вход и своя роль.') }}</p>
    </div>
    <button *ngIf="!unavailable && !showForm" type="button" class="btn btn--primary" (click)="openForm()">
      {{ t('company.members.add', 'Добавить сотрудника') }}
    </button>
  </header>

  <div *ngIf="success" class="cm-msg cm-msg--ok" role="status">{{ success }}</div>
  <div *ngIf="error" class="cm-msg cm-msg--err" role="alert">{{ error }}</div>

  <div *ngIf="loading" class="cm-empty">{{ t('common.loading', 'Загрузка...') }}</div>
  <div *ngIf="!loading && unavailable" class="cm-empty">
    {{ t('company.members.unavailable', 'Управление сотрудниками недоступно. Оно доступно администратору компании.') }}
  </div>

  <!-- Форма добавления -->
  <form *ngIf="showForm" class="cm-card cm-form" [formGroup]="form" (ngSubmit)="submit()">
    <h2>{{ editingId !== null ? t('company.members.editTitle', 'Редактирование сотрудника') : t('company.members.newTitle', 'Новый сотрудник') }}</h2>
    <div class="cm-grid">
      <div class="field">
        <label for="cm-fullName">{{ t('company.members.fullName', 'Полное имя') }}</label>
        <input id="cm-fullName" type="text" formControlName="fullName" class="input" autocomplete="off" />
        <small class="field-err" *ngIf="form.get('fullName')?.touched && form.get('fullName')?.invalid">
          {{ t('company.members.required', 'Это поле обязательно для заполнения') }}
        </small>
      </div>
      <div class="field">
        <label for="cm-email">{{ t('company.members.email', 'Email (логин для входа)') }}</label>
        <input id="cm-email" type="email" formControlName="email" class="input" autocomplete="off" />
        <small class="field-err" *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
          {{ t('company.members.emailInvalid', 'Введите корректный email адрес') }}
        </small>
      </div>
      <div class="field">
        <label for="cm-phone">{{ t('company.members.phone', 'Телефон') }}</label>
        <input id="cm-phone" type="tel" formControlName="phone" class="input" autocomplete="off" />
      </div>
      <div class="field" *ngIf="editingId === null">
        <label for="cm-password">{{ t('company.members.password', 'Пароль') }}</label>
        <input id="cm-password" type="password" formControlName="password" class="input" autocomplete="new-password" />
        <small class="field-hint" *ngIf="!(form.get('password')?.touched && form.get('password')?.invalid)">
          {{ t('company.members.passwordHint', 'Минимум 6 символов. Сообщите пароль сотруднику.') }}
        </small>
        <small class="field-err" *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
          {{ t('company.members.passwordInvalid', 'Минимум 6 символов') }}
        </small>
      </div>
    </div>

    <fieldset class="roles">
      <legend>{{ t('company.members.role', 'Роль') }}</legend>
      <label *ngFor="let r of roles" class="role-option">
        <input type="radio" formControlName="companyRole" [value]="r" />
        <span class="role-option__text">
          <strong>{{ roleName(r) }}</strong>
          <span>{{ roleHint(r) }}</span>
        </span>
      </label>
    </fieldset>

    <div class="cm-actions">
      <button type="button" class="btn btn--ghost" (click)="cancelForm()">{{ t('common.cancel', 'Отмена') }}</button>
      <button type="submit" class="btn btn--primary" [disabled]="submitting">
        {{ submitting ? t('company.members.saving', 'Сохраняем...') : (editingId !== null ? t('company.members.save2', 'Сохранить') : t('company.members.save', 'Добавить')) }}
      </button>
    </div>
  </form>

  <!-- Список -->
  <section *ngIf="!loading && !unavailable" class="cm-card cm-list">
    <div class="cm-table-wrap">
      <table class="cm-table">
        <thead>
          <tr>
            <th>{{ t('company.members.fullName', 'Полное имя') }}</th>
            <th>{{ t('company.members.emailShort', 'Email') }}</th>
            <th>{{ t('company.members.role', 'Роль') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let m of members">
            <tr>
              <td data-label="">
                <strong>{{ m.fullName }}</strong>
                <span *ngIf="m.id === currentUserId" class="me">{{ t('company.members.you', 'это вы') }}</span>
                <div class="muted" *ngIf="m.phone">{{ m.phone }}</div>
              </td>
              <td class="muted">{{ m.email }}</td>
              <td>
                <select class="input input--sm" [ngModel]="m.companyRole" (ngModelChange)="changeRole(m, $event)"
                        [disabled]="m.id === currentUserId" [attr.aria-label]="t('company.members.role', 'Роль')">
                  <option *ngFor="let r of roles" [value]="r">{{ roleName(r) }}</option>
                </select>
              </td>
              <td class="cm-row-actions">
                <button type="button" class="link" (click)="openEdit(m)">{{ t('company.members.edit', 'Изменить') }}</button>
                <button type="button" class="link" (click)="startPassword(m)">{{ t('company.members.changePassword', 'Сменить пароль') }}</button>
                <button *ngIf="m.id !== currentUserId" type="button" class="link link--danger" (click)="remove(m)">
                  {{ t('company.members.remove', 'Отключить') }}
                </button>
              </td>
            </tr>
            <tr *ngIf="passwordMemberId === m.id" class="pw-row">
              <td colspan="4">
                <div class="pw-edit">
                  <input type="password" class="input input--sm" [formControl]="passwordControl" autocomplete="new-password"
                         [attr.aria-label]="t('company.members.newPassword', 'Новый пароль')"
                         [placeholder]="t('company.members.newPassword', 'Новый пароль')" />
                  <button type="button" class="btn btn--primary btn--sm" (click)="savePassword(m)">{{ t('company.members.save2', 'Сохранить') }}</button>
                  <button type="button" class="btn btn--ghost btn--sm" (click)="passwordMemberId = null">{{ t('common.cancel', 'Отмена') }}</button>
                  <small class="field-err" *ngIf="passwordControl.touched && passwordControl.invalid">{{ t('company.members.passwordInvalid', 'Минимум 6 символов') }}</small>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>
</div>
